import { CurrencyType, SettledAmountDto } from '@tiendanube/common';
import AmountDto from '@tiendanube/common/dist/src/domains/payments/refund/AmountDto';

export interface CrossBorderCalculationsResult {
  getPrimaryTotal: () => AmountDto;
  showSettledAsSecondaryInTotal: () => boolean;
}

function useCrossBorderCalculations(
  total: number,
  currency: CurrencyType,
  settledAmount: SettledAmountDto | undefined,
  orderHasSubtotal: boolean,
): CrossBorderCalculationsResult {
  const useSettledAsPrimary = settledAmount && orderHasSubtotal;

  const getPrimaryTotal = () =>
    ({
      value: useSettledAsPrimary ? settledAmount.value : total.toString(),
      currency: useSettledAsPrimary ? settledAmount.currency : currency,
    } as AmountDto);

  // If the order has a subtotal, all amounts that follow (including the total)
  // are already shown in the settled currency. In that case, display the
  // settled amount (with tooltip) only in the subtotal, not again in the total.
  const showSettledAsSecondaryInTotal = () => !orderHasSubtotal;

  return {
    getPrimaryTotal,
    showSettledAsSecondaryInTotal,
  };
}

export default useCrossBorderCalculations;
